import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";

const LeadershipEffectiveDateModal = ({ show, changes, project, onConfirm, onCancel }) => {
  const [dates, setDates] = useState({});

  useEffect(() => {
    if (!show) {
      setDates({});
      return;
    }
    setDates(Object.fromEntries(changes.map((change) => [change.role, null])));
  }, [changes, show]);

  useEffect(() => {
    if (!show) return undefined;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = "auto"; };
  }, [show]);

  if (!show) return null;
  const complete = changes.every((change) => dates[change.role]);

  return <>
    <div className="modal fade show" style={{ display: "block" }} role="dialog" aria-modal="true" aria-labelledby="leadership-date-title">
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <div>
              <p id="leadership-date-title" className="modal-title fw-600 fs-6 mb-1">Leadership change effective dates</p>
              <small className="text-muted">Select when each member change became effective. These dates will be stored in project member history.</small>
            </div>
            <button type="button" className="btn-close" onClick={onCancel} aria-label="Close" />
          </div>
          <div className="modal-body">
            {changes.map((change) => <div className="row mb-3 align-items-center" key={change.role}>
              <div className="col-md-4">
                <strong className="d-block">{change.label}</strong>
                <small className="text-muted">{change.previousName || "Not assigned"} → {change.nextName || "Unassigned"}</small>
              </div>
              <div className="col-md-8">
                <DatePicker
                  showIcon
                  toggleCalendarOnIconClick
                  placeholderText="Select effective date"
                  dateFormat="MM-dd-yyyy"
                  selected={dates[change.role] || null}
                  className="border custom-date"
                  onChange={(date) => setDates((current) => ({ ...current, [change.role]: date }))}
                  minDate={project?.startDate ? new Date(project.startDate) : project?.sowStartDate ? new Date(project.sowStartDate) : null}
                  maxDate={project?.sowEndDate ? new Date(project.sowEndDate) : null}
                  required
                  onKeyDown={(event) => { if (event.key !== "Backspace" && event.key !== "Delete") event.preventDefault(); }}
                />
              </div>
            </div>)}
          </div>
          <div className="modal-footer justify-content-center">
            <button type="button" className={`theme-button ${complete ? "" : "disabled"}`} disabled={!complete} onClick={() => onConfirm(dates)}>Continue and save</button>
            <button type="button" className="theme-button bg-grey mx-3" onClick={onCancel}>Cancel</button>
          </div>
        </div>
      </div>
    </div>
    <div className="modal-backdrop fade show" />
  </>;
};

export default LeadershipEffectiveDateModal;
